export const PROVIDER_CONNECT = "PC";
export const PROVIDER_HUB = "PH";